import React from "react";

const NavbarIcon = ({ fillColor = "#919CB4" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 7.81V16.19C22 19.83 19.83 22 16.19 22H9.75V2H16.19C19.83 2 22 4.17 22 7.81Z"
        fill={fillColor}
      />
      <path
        d="M8.25 2V22H7.81C4.17 22 2 19.83 2 16.19V7.81C2 4.17 4.17 2 7.81 2H8.25Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default NavbarIcon;
